import type { Status } from '../../models/common/Status';
import type { TaskCampaignFilters } from '../../models/Task/campaignFilters';

export interface OutboundTaskTypeOption {
  value: string;
  label: string;
}

export interface OutboundTaskTypesPayload {
  options: OutboundTaskTypeOption[];
}

export interface OutgoingStatisticsState {
  processedTasksCount: number;
  inProcessingTasksCount: number;
  notProcessedTasksCount: number;
  processedTasksAttemptCount: number;
  oneAttemptBusinessResultTasksCount: number;
  twoAttemptBusinessResultTasksCount: number;
  threeAndMoreAttemptBusinessResultTasksCount: number;
  oneAttemptTechnicalResultTasksCount: number;
  twoAttemptTechnicalResultTasksCount: number;
  threeAndMoreAttemptTechnicalResultTasksCount: number;
  zeroAttemptTasksCount: number;
  threeAndMoreAttemptBusinessResultTasksAttemptCount: number;
  threeAndMoreAttemptTechnicalResultTasksAttemptCount: number;
  answeringMachineTasksCount: number;
  noAnswerTasksCount: number;
  errorTasksCount: number;
  hangUpTasksCount: number;
  failedTasksAttemptCount: number;
  botDetectedAttemptCount: number;
  noAnswerAttemptCount: number;
  errorAttemptCount: number;
  hangUpAttemptCount: number;
  notIdentifiedTasksAttemptCount: number;
  failedTasksCount: number;
  confirmedTasksCount: number;
  cancelledTasksCount: number;
  waitingListTasksCount: number;
  cancelledByClinicTasksCount: number;
  rescheduledTasksCount: number;
  rescheduledByClinicTasksCount: number;
  operatorHandedTasksCount: number;
  notIdentifiedTasksCount: number;
  notReceivedTasksCount: number;
  blockedTasksCount: number;
  outboundTaskTypeOptions: OutboundTaskTypeOption[];
  currentRequestId?: string;
  lastSuccessfulRequest?: OutgoingStatisticsRequest;
  status: Status;
}

export interface OutgoingStatisticsResponse {
  processedTasksCount: number;
  inProcessingTasksCount: number;
  notProcessedTasksCount: number;
  processedTasksAttemptCount: number;
  oneAttemptBusinessResultTasksCount: number;
  twoAttemptBusinessResultTasksCount: number;
  threeAndMoreAttemptBusinessResultTasksCount: number;
  oneAttemptTechnicalResultTasksCount: number;
  twoAttemptTechnicalResultTasksCount: number;
  threeAndMoreAttemptTechnicalResultTasksCount: number;
  zeroAttemptTasksCount: number;
  threeAndMoreAttemptBusinessResultTasksAttemptCount: number;
  threeAndMoreAttemptTechnicalResultTasksAttemptCount: number;
  answeringMachineTasksCount: number;
  noAnswerTasksCount: number;
  errorTasksCount: number;
  hangUpTasksCount: number;
  failedTasksAttemptCount: number;
  botDetectedAttemptCount: number;
  noAnswerAttemptCount: number;
  errorAttemptCount: number;
  hangUpAttemptCount: number;
  notIdentifiedTasksAttemptCount: number;
  failedTasksCount: number;
  confirmedTasksCount: number;
  cancelledTasksCount: number;
  waitingListTasksCount: number;
  cancelledByClinicTasksCount: number;
  rescheduledTasksCount: number;
  rescheduledByClinicTasksCount: number;
  operatorHandedTasksCount: number;
  notIdentifiedTasksCount: number;
  notReceivedTasksCount: number;
  blockedTasksCount: number;
}

export interface OutgoingStatisticsRequest extends TaskCampaignFilters {
  From: string;
  To: string;
  ClinicIds: string[];
  States?: string[];
  AttemptStates?: string[];
  Result?: string[];
  Types?: string[];
  TextSearch?: string;
}

export const initialState: OutgoingStatisticsState = {
  processedTasksCount: 0,
  inProcessingTasksCount: 0,
  notProcessedTasksCount: 0,
  processedTasksAttemptCount: 0,
  oneAttemptBusinessResultTasksCount: 0,
  twoAttemptBusinessResultTasksCount: 0,
  threeAndMoreAttemptBusinessResultTasksCount: 0,
  oneAttemptTechnicalResultTasksCount: 0,
  twoAttemptTechnicalResultTasksCount: 0,
  threeAndMoreAttemptTechnicalResultTasksCount: 0,
  zeroAttemptTasksCount: 0,
  threeAndMoreAttemptBusinessResultTasksAttemptCount: 0,
  threeAndMoreAttemptTechnicalResultTasksAttemptCount: 0,
  answeringMachineTasksCount: 0,
  noAnswerTasksCount: 0,
  errorTasksCount: 0,
  hangUpTasksCount: 0,
  failedTasksAttemptCount: 0,
  botDetectedAttemptCount: 0,
  noAnswerAttemptCount: 0,
  errorAttemptCount: 0,
  hangUpAttemptCount: 0,
  notIdentifiedTasksAttemptCount: 0,
  failedTasksCount: 0,
  confirmedTasksCount: 0,
  cancelledTasksCount: 0,
  waitingListTasksCount: 0,
  cancelledByClinicTasksCount: 0,
  rescheduledTasksCount: 0,
  rescheduledByClinicTasksCount: 0,
  operatorHandedTasksCount: 0,
  notIdentifiedTasksCount: 0,
  notReceivedTasksCount: 0,
  blockedTasksCount: 0,
  outboundTaskTypeOptions: [],
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};
